  <div *ngIf="isMobileDevice(); then footerMobile; else footerDesktop"></div>
  <ng-template #footerDesktop>
  <footer id="parmed-footer" class="new-footer">
    <mat-divider *ngIf="websiteName == 'Parmed'"></mat-divider>
    <div class="new-footer-container" *ngIf="websiteName == 'Parmed'">
      <!--footer-left-->
      <div class="new-footer-box new-footer-left">
        <ul>
          <li>
            <a id="footer-contact-us" routerLink="/contact-us">Contact us</a>
          </li>
          <li *ngIf="websiteName == 'Parmed'">
            <a id="footer-opportunities" [routerLink]="[routes.employment]"
              >Employment Opportunities</a
            >
          </li>
          <li>
            <a id="footer-aboutus" (click)="onAboutUsClick()">About Us</a>
          </li>
        </ul>
        <div id="footer-left-widget"></div>
      </div>
      <!--footer-left-->
      <!--footer-center-->
      <div class="new-footer-box new-footer-center">
        <span *ngIf="websiteName =='Parmed'">
          <a href="https://mybadges.us.openbadges.me/api/badgeitem/ce5e7ae6-3983-41a5-94f8-2f20cf884d2f/metadata" target="_blank"> 
          <img
          src="/assets/images/NABP.png"
          height="90"
          alt="NABP"
          title="Drug Distributor"
          />
          </a>
        </span>
      </div>
      <!--footer-center-->
      <!--footer-right-->
      <div class="new-footer-box new-footer-right">
        <ul>
          <li *ngIf="websiteName == 'Parmed'">
            <a id="footer-help" [routerLink]="[routes.help]">Help</a>
          </li>
          <div *ngIf="websiteName == 'Parmed'" class="legal-li">
            <li>
              <a
              id="footer-product-services"
              class="li-font-size"
              [routerLink]="[routes.productservices]"
              >Products and Services</a
            >
            </li>
          </div>
          <div *ngIf="websiteName == 'Parmed'" class="legal-li">
            <li>
              <a
                id="footer-legal"
                class="li-font-size"
                [routerLink]="[routes.legal]"
                >Legal</a
              >
            </li>
          </div>
          <li *ngIf="websiteName == 'Parmed'">
            <a id="footer-privacy" [routerLink]="[routes.privacy]"
              >Privacy Policy</a
            >
          </li>
        </ul>
        <div id="footer-right-widget"></div>
      </div>
      <!--footer-right-->
    </div>
    <div class="new-footer-container" *ngIf="websiteName == 'Major'">
      <div class="footer-content">
        <div class="footer-column" style="margin-left: -50px;">
        <a href="https://app.us.openbadges.me/view/#!/badge?badgeid=74055885-07ae-4e13-a91b-e15d57d49c6b" target="_blank">
         <img src="/assets/images/Major/FooterLogo.png" height="120px" alt="NABP" title="Drug Distributor" style="align-items: center;
    margin-top: 80px;
    margin-left: 40px;"  /></a> 
        </div>
        <div class="footer-column">
          <h4 >Quick links</h4>
          <ul>
            <li>
              <a id="footer-aboutus" (click)="routeClick(routes.majorAboutUs)">About</a>
            </li>
            <li><a id="footer-product-services" class="li-font-size"
                  (click)="routeClick(routes.productCatalogList)">Products</a>
              </li>
              <li>
                 <a (click)="routeClick(routes.MajorAmazon)">Amazon</a>
              </li>
            <li>
              <a id="footer-news" (click)="routeClick(routes.majorNews)">News</a>
            </li>
            <li>
                <a id="footer-help" (click)="routeClick(routes.majorHelp)">Help</a>
            </li>
            <li>
             <a id="footer-help" (click)="routeClick(routes.contactUs)">Contact Us</a>
            </li>
            <li>
             <a id="footer-help" (click)="routeClick(routes.packageInsert)">Package Inserts</a>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h4>Other</h4>
          <ul>
            <li>
               <a id="footer-legal" class="li-font-size" (click)="routeClick(routes.majorLegal)">Legal</a>
            </li>
            <li>
                <a id="footer-privacy" (click)="routeClick(routes.majorPrivacy)">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h4>Follow Us</h4>
          <ul>
            <li>
              <a id="footer-linkedin" href="https://www.linkedin.com/company/major-pharmaceuticals"
                target="_blank">LinkedIn
                <span class="linkedin-logo">in</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h4>Contact Us</h4>
          <div class="footer-left-bottom" id="footer-left-widget"></div>
        </div>
        <div class="footer-bottom">
          <div id="footer-right-widget"></div>
        </div>
      </div>
    </div>
  </footer>
  </ng-template>
  <ng-template #footerMobile>
  <footer id="parmed-footer" class="new-footer">
    <mat-divider *ngIf="websiteName == 'Parmed'"></mat-divider>
    <div class="new-footer-container" *ngIf="websiteName == 'Parmed'">
      <div class="new-footer-box">
         <div id="footer-right-widget"></div>
        <ul class="align-items">
          <!-- <li>
            <a id="footer-privacy" [routerLink]="[routes.mobile.privacy]"
              >Privacy Policy</a
            >
          </li> -->
          <div *ngIf="websiteName == 'Parmed'">
              <li>
                <a
                  id="footer-privacy"
                  class="footer-privacy"
                  [routerLink]="[routes.mobile.privacy]"
                  >Privacy Policy</a
                >
              </li>
            </div>
          <div *ngIf="websiteName == 'Parmed'">
            <li>
              <a
                id="footer-legal"
                class="footer-legal"
                [routerLink]="[routes.mobile.legal]"
                >Legal</a
              >
            </li>
          </div>
        </ul>
      </div>
    </div>
    <div class="new-footer-container footer-container" *ngIf="websiteName == 'Major'">
      <div class="footer-content">
        <div class="footer-column quicklinks" >
          <h4 style="margin-left: -10px !important;">Quick links</h4>
          <ul class="items-align">
            <li>
              <a id="footer-aboutus" (click)="onAboutUsClick()">About</a>
            </li>
                  <li><a id="footer-product-services" class="li-font-size" 
                (click)="routeClick(routes.productCatalogList)">Products</a></li>
              <li>
                 <a (click)="routeClick(routes.MajorAmazon)">Amazon</a>
              </li>
            <li>
                   <a id="footer-news" (click)="routeClick(routes.majorNews)">News</a>
            </li>
            <li>
             <a id="footer-help" (click)="routeClick(routes.majorHelp)">Help</a>
            </li>
            <li>
              <a id="footer-help" (click)="routeClick(routes.contactUs)">Contact Us</a>
            </li>
            <li>
                <a  (click)="routeClick(routes.packageInsert)">Package Inserts</a>
            </li>
          </ul>
        </div>
        <div class="footer-column other">
          <h4>Other</h4>
          <ul>
            <li>
              <a id="footer-legal" class="li-font-size" (click)="routeClick(routes.mobile.majorLegal)">Legal</a>
            </li>
            <li>
              <a id="footer-privacy" (click)="routeClick(routes.mobile.majorPrivacy)">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div class="footer-column linkedin">
            <h4>Follow us
              <a id="footer-linkedin" href="https://www.linkedin.com/company/major-pharmaceuticals"
            target="_blank">LinkedIn
            <span class="linkedin-logo">in</span>
          </a>
            </h4>
        </div>
        <div class="footer-column contactus">
          <h4>Contact Us</h4>
          <div class="footer-left-bottom" id="footer-left-widget"></div>
        </div>
        <div class="footer-column">
          <a href="https://app.us.openbadges.me/view/#!/badge?badgeid=74055885-07ae-4e13-a91b-e15d57d49c6b" target="_blank">
          <img src="/assets/images/Major/FooterLogo.png" height="100" alt="NABP" title="Drug Distributor" /></a> 
        </div>
        <div class="footer-column bottom">
          <div id="footer-right-widget" style="margin-top: 20px;"></div>
        </div>
      </div>
      </div>
    
  </footer>
  </ng-template>

